import React from 'react'
export const InfoContext = React.createContext()